var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tree-select',{ref:"treeSelect",staticStyle:{"width":"100%"},attrs:{"props":_vm.props,"options":_vm.data,"value":_vm.value1,"clearable":true,"accordion":true,"parent-select":_vm.parent},on:{"node-select":function($event){return _vm.onTreeSelect($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }